import React from 'react';
import styles from './index.module.scss';

// Components
import { Card, Table, Button } from 'react-bootstrap';

const MessagesList = (props) => {

    return (
        <Card className={styles.MessagesList}>
            <Card.Body>
                <h5>Current messages</h5>
                <hr />
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>id</th>
                            <th>Name</th>
                            <th>Phone/Email</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>Pedro Ramirez</td>
                            <td>pramirez1954@yahoo.com</td>
                            <td>
                                <Button className={styles.Button} size="sm" variant="primary">View Message</Button>
                                <Button className={styles.Button} size="sm" variant="danger">Delete</Button>
                            </td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>Carlos Gutierrez</td>
                            <td>(305)635-9694</td>
                            <td>
                                <Button className={styles.Button} size="sm" variant="primary">View Message</Button>
                                <Button className={styles.Button} size="sm" variant="danger">Delete</Button>
                            </td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>Jesus Lopez</td>
                            <td>(786)974-3455</td>
                            <td>
                                <Button className={styles.Button} size="sm" variant="primary">View Message</Button>
                                <Button className={styles.Button} size="sm" variant="danger">Delete</Button>
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </Card.Body>
        </Card>
    );
}

export default MessagesList;